import { useCallback, useEffect, useMemo, useState } from 'react';
import SettingsMainLayout from 'components/organisms/settings/MainLayoutV2';
import {
  useSettingsForm,
  useSettingsMainForm,
} from 'hooks/formStates/settings';
import routeCodes from 'common/constants/route-codes';
import { useCommon } from 'redux/common/use-common';
import SettingsApi from 'libs/api/settings';
import UIHelper from 'services/UIHelper';
import { useHistory } from 'react-router-dom';
import MainForm from '../../components/molecules/settings/MainForm';
import { ContentWrapper } from '../../components/organisms/SettingsForm/styled';

const SettingsV2Delivery = ({ history }) => {
  const [localUpdateInProcess, setLocalUpdateInProcess] = useState(false);
  const [errors, setErrors] = useState(null);

  const {
    onSelectConfig,
    onChange,
    localState,
    dataForRequest,
    deliveryZips,
    handleChangeDeliveryZips,
    onSubmit,
    errors: reduxErrors,
    onClickCreateDelivery,
    onDeleteDelivery,
  } = useSettingsMainForm(true);

  const onCancel = useCallback(() => {
    history.push(routeCodes.home);
  }, [history]);

  // useEffect(() => {
  //   const disableScrolling = () => {
  //     const x = window.scrollX;
  //     const y = window.scrollY;
  //     window.onscroll = function () {
  //       window.scrollTo(x, y);
  //     };
  //   };
  //   window.onscroll = disableScrolling;
  //   return () => {
  //     window.onscroll = () => {};
  //   };
  // }, []);

  const {
    deliveryDates,
    deliveryActiveTab,
    fetchDeliveryDates,
    changeDeliveryDayConfig,
    onChangeDeliveryTab,
    setHoursErrors,
    onChangeMaximum,
    onChangeExceptionDay,
    onAddExceptionData,
    isLoading,
    onDeleteException,
    setDeliveryDates,
  } = useSettingsForm();
  const { currentRestaurant } = useCommon();

  const settingsApi = useMemo(() => {
    return new SettingsApi(currentRestaurant?.id);
  }, [currentRestaurant]);

  const handleUpdateSettingTimes = useCallback(async () => {
    setLocalUpdateInProcess(true);
    try {
      await settingsApi.updateOpeningHours(
        deliveryActiveTab,
        deliveryDates[deliveryActiveTab],
      );
      const { data: newData } = await settingsApi.get(
        `opening_hours/${deliveryActiveTab}`,
      );
      setDeliveryDates((state) => ({
        ...state,
        [deliveryActiveTab]: {
          ...state[deliveryActiveTab],
          isFetched: true,
          errors: null,
          ...newData,
        },
      }));
      onSubmit();
      // UIHelper.showCreateOrUpdateSuccess();
    } catch (e) {
      setErrors(e?.response?.data?.opening_hours);
    } finally {
      setLocalUpdateInProcess(false);
    }
  }, [deliveryActiveTab, dataForRequest, deliveryDates, onSubmit, settingsApi]);

  return (
    <SettingsMainLayout
      localState={localState}
      onChange={onChange}
      onSubmitAction={handleUpdateSettingTimes}
      onSelectConfig={onSelectConfig}
      onCancel={onCancel}
      setOpeningHourErrors={setErrors}
      openingHourErrors={errors}
      localUpdateInProcess={localUpdateInProcess}
      changeDeliveryDayConfig={changeDeliveryDayConfig}
      deliveryActiveTab={deliveryActiveTab}
      deliveryDates={deliveryDates}
      fetchDeliveryDates={fetchDeliveryDates}
      onChangeDeliveryTab={onChangeDeliveryTab}
      setHoursErrors={setHoursErrors}
      onChangeMaximum={onChangeMaximum}
      onChangeExceptionDay={onChangeExceptionDay}
      onAddExceptionData={onAddExceptionData}
      isLoading={isLoading}
      onDeleteException={onDeleteException}
      setDeliveryDates={setDeliveryDates}
    >
      <ContentWrapper className='ristora-scroll'>
        <MainForm
          data={localState}
          onChange={onChange}
          deliveryZips={deliveryZips}
          onClickCreateDelivery={onClickCreateDelivery}
          onDeleteDelivery={onDeleteDelivery}
          handleChangeDeliveryZips={handleChangeDeliveryZips}
          showOtherBlocks={true}
          errors={reduxErrors}
        />
      </ContentWrapper>
    </SettingsMainLayout>
  );
};

export default SettingsV2Delivery;
